const currencyToString = (
  num,
  {
    locale = "en-US",
    currency = "USD",
    minimumFractionDigits = 0,
    maximumFractionDigits = 1,
    abbreviationFormats = [
      { value: 1e12, symbol: "T" },
      { value: 1e9, symbol: "B" },
      { value: 1e6, symbol: "M" },
      { value: 1e3, symbol: "K" }
    ]
  }
) => {
  if (num == null || typeof num !== "number") {
    return num;
  }

  let format;
  if (abbreviationFormats != null) {
    format = abbreviationFormats.find(f => num >= f.value);
  }

  if (format != null) {
    const { value, symbol } = format;
    const formatted = (num / value).toLocaleString(locale, {
      style: "currency",
      currency,
      minimumFractionDigits,
      maximumFractionDigits
    });
    const parts = formatted.match(/([\D]*)([\d.,]+)([\D]*)/);
    return `${parts[1]}${parts[2]}${symbol}${parts[3]}`;
  }

  return num.toLocaleString(locale, {
    style: "currency",
    currency,
    minimumFractionDigits,
    maximumFractionDigits
  });
};

export default currencyToString;
